import { mount } from "svelte";
import ProjectsMarketingModal from "../../../../svelte/src/modals/MarketingModal/ProjectsMarketingModal/ProjectsMarketingModal.svelte";

export const initializeMarketingModal = () => {
  const $wrapper = $("#wrapper");

  const marketingModalContainer = document.createElement("div");
  marketingModalContainer.id = "projects-marketing-modal";
  $wrapper.append(marketingModalContainer);

  mount(ProjectsMarketingModal, { target: marketingModalContainer });
};
